// extracted by mini-css-extract-plugin
export var signupFormArea = "SignupForm-module--signup-form-area--1b9FY";
export var signupButtonArea = "SignupForm-module--signup-button-area--2v9jt";
export var signupField = "SignupForm-module--signup-field--LX_4V";
export var signupFormValidationError = "SignupForm-module--signupFormValidationError--1YORy";
export var errorInput = "SignupForm-module--errorInput--3e-0z";
export var columnsContainer = "SignupForm-module--columnsContainer--JCo05";
export var left = "SignupForm-module--left--YnsQP";